/* eslint-disable */
import {Popup} from "./ui/popup";
import {Modal} from "./ui/modal";
import {Dialog} from './ui/dialog';
import {Slider} from './ui/slider';
import {Spinner} from "./ui/spinner";
import {Tab} from './ui/tab';
import {Accordion} from './ui/accordion';
import {StickyMenu} from './ui/stickyMenu';
import {NotificationBar} from './ui/notificationBar';
import {MobileHeaderNav} from "./components/mobileHeaderNav";
import {DesktopHeaderNav} from './components/desktopHeaderNav';
import {FooterCookiesBar} from "./components/footer";
import {Testimonials} from './components/testimonials';
import {Faq} from './components/faq';
import {LanguageChangerCookie} from './components/languageChangerCookie';
import {FormDataHandler} from './components/forms/formDataHandler';
import {RemindPasswordForm} from './components/forms/remindPassword';
import {ContactForm} from './components/forms/contact';
import {SetPasswordForm} from './components/forms/setPassword';
import Pristine from 'pristinejs';


Popup.init();
Modal.init();
Dialog();
Slider();
Spinner();
MobileHeaderNav();
DesktopHeaderNav();
FooterCookiesBar();
Testimonials();
Tab();
Accordion();
StickyMenu();
NotificationBar();
Faq();
LanguageChangerCookie();
FormDataHandler();
RemindPasswordForm();
SetPasswordForm();
ContactForm();


/* Wonderhosue JS */

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }
  if (typeof Array.prototype.forEach != 'function') {
    Array.prototype.forEach = function (callback) {
        for (var i = 0; i < this.length; i++) {
            callback.apply(this, [this[i], i, this]);
        }
     };
    }

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
     }

Array.from(document.querySelectorAll('[data-tab]')).forEach((tab) => {
    tab.addEventListener('click', () => {
        var obj = {
            Title: document.title,
            Url: location.origin + location.pathname + '?' + tab.getAttribute('data-tab')
        };
        window.history.pushState(obj, obj.Title, obj.Url);

        if (typeof gtag === "function") {
            gtag('set', 'page_path', location.pathname + '?' + tab.getAttribute('data-tab'));
            gtag('event', 'page_view');
        }
        if (typeof ga === "function") {
            ga('set', 'page_path', location.pathname + '?business&submit');
            ga('event', 'page_view');
        }

        if (tab.hasAttribute('data-tab-onchange')) {
            eval(tab.getAttribute('data-tab-onchange'))
        }

        if (document.querySelector('[data-tab-active]')) document.querySelector('[data-tab-active]').removeAttribute('data-tab-active');
        tab.setAttribute('data-tab-active', '');

        if (document.querySelector('[data-tab-content-active]')) document.querySelector('[data-tab-content-active]').removeAttribute('data-tab-content-active');
        document.querySelector(`[data-tab-content="${tab.getAttribute('data-tab')}"]`).setAttribute('data-tab-content-active', '');

        if (document.querySelector('[data-tab-background-active]')) document.querySelector('[data-tab-background-active]').removeAttribute('data-tab-background-active');
        document.querySelector(`[data-tab-background="${tab.getAttribute('data-tab')}"]`).setAttribute('data-tab-background-active', '');

        if (document.querySelector('[data-tab-wrapper-active]')) document.querySelector('[data-tab-wrapper-active]').removeAttribute('data-tab-wrapper-active');
        document.querySelector(`[data-tab-wrapper="${tab.getAttribute('data-tab')}"]`).setAttribute('data-tab-wrapper-active', '');

    })
});

let form = document.querySelector('#hook-business form');
let submitButton = document.querySelector('#hook-business form button[type=submit]');
// Extend Pristine.js

Pristine.addValidator("phone", function(value, param1, param2) {
    // here `this` refers to the respective input element
    return parseInt(param1) <= value.length && value.length <= parseInt(param2)

}, "The length (${0}) must be between ${1} and ${2}", 5, false);

if (document.querySelector("#business_phone")) {
    document.querySelector("#business_phone").oninput = function () {
        if (this.value.length > 13) {
            this.value = this.value.slice(0,13);
        }
    }
}

// Form Validation
const initPristine = (form) => {
    if (!form) {
        return;
    }

    const pristine = new Pristine(form, {
        classTo: 'form-group',
        errorClass: 'form-group--error',
        successClass: 'form-group--success',
        errorTextParent: 'form-group',
        errorTextTag: 'div',
        errorTextClass: 'text'
    });

    form.addEventListener('submit', function (event) {
        if (event.preventDefault) {
            event.preventDefault()
        } else {
            event.returnValue = false;
        }
        if (pristine.validate()) {
            if (form.hasAttribute('data-form-onsubmit')) {
                eval(form.getAttribute('data-form-onsubmit'))
            }
            if (typeof gtag === "function") {
                gtag('set', 'page_path', location.pathname + '?business&submit');
                gtag('event', 'page_view');
            }
            if (typeof ga === "function") {
                ga('set', 'page_path', location.pathname + '?business&submit');
                ga('event', 'page_view');
            }

            form.classList.add('loading');
            form.submit();
        } else {
        }
    });


    Array.from(form.querySelectorAll('.postcode input')).forEach((input) => {
        input.addEventListener('keydown', (e) => {
            console.log(parseInt(e.keyCode) === 8);
            let regexp = new RegExp("[0-9]{1}");
            if (parseInt(e.keyCode) !== 8 && !e.key.match(regexp)) {
                if (e.preventDefault) {
                    e.preventDefault()
                } else {
                    e.returnValue = false;
                }
                return false;
            }

        })
    });

    window.pristine = pristine;
}

initPristine(form);